import gql from 'graphql-tag'

export const GetRmaOrderView = gql`
  query GetRmaOrder(
    $lastname: String!
    $orderId: String!
    $search: String!
    $type: Boolean!
  ) {
    GetRmaOrder ( input:
    {
      lastname: $lastname
      order_id: $orderId
      search: $search
      type: $type
    }) {
      order {
        grand_total
        subtotal
        discount
        shipping_amount
        increment_id
        shipping_method
        payment_method
        created_at
        customer_name
        status
        items {
          item_id
          name
          sku
          price
          qty_ordered
          subtotal
          is_returnable
        }
        shipping_address {
          city
          company
          country
          fax
          firstname
          lastname
          postcode
          region
          street
          telephone
        }
        billing_address {
          city
          company
          country
          fax
          firstname
          lastname
          postcode
          region
          street
          telephone
        }
      }
      result
      message
    }
  }
`

export const getAttributes = gql`
query {
  GetRMAFormAttributes {
    attributes {
      id
      label
      code
      options {
        option_id
        option_label
      }
    }
  }
}
`

export const CreateRmaOrder = gql`
  mutation CreateRmaOrder (
    $search: String!
    $lastname: String!
    $orderId: String!
    $type: Boolean!
    $customerCustomEmail: String
    $rmaComment: String
    $items: [RmaOrderItemInput]!
  ) {
    CreateRmaOrder(
      input: {
        search: $search,
        lastname: $lastname,
        order_id: $orderId,
        type: $type
      }
      customer_custom_email: $customerCustomEmail,
      rma_comment: $rmaComment,
      items: $items,
    ) {
      result
      message
    }
  }
`
